/**
 * 문자열이 이미 URL 인코딩되었는지 확인합니다.
 * @param {string} str - 확인할 문자열
 * @returns {boolean} 인코딩 여부
 */
const isEncoded = (str) => {
  try {
    // %로 시작하는 인코딩된 문자가 있는지 확인
    return str !== decodeURIComponent(str)
  } catch (e) {
    return false
  }
}

/**
 * 이미지 URL의 파일명 부분만 따로 인코딩하여 안전한 URL을 생성합니다.
 * @param {string} url - 원본 URL
 * @returns {string} 인코딩된 URL
 */
const encodeImageUrl = (url) => {
  if (!url) return ''

  try {
    // URL을 경로와 파일명으로 분리
    const lastSlashIndex = url.lastIndexOf('/')
    if (lastSlashIndex === -1) {
      return isEncoded(url) ? url : encodeURIComponent(url)
    }

    const path = url.substring(0, lastSlashIndex + 1)
    const filename = url.substring(lastSlashIndex + 1)

    // 파일명이 이미 인코딩되어 있는지 확인
    if (isEncoded(filename)) {
      return url
    }

    // 파일명만 강력하게 인코딩
    return path + encodeURIComponent(filename)
  } catch (e) {
    console.error('URL 인코딩 중 오류 발생:', e)
    return url
  }
}

/**
 * URL을 CSS background-image에 사용할 수 있는 형식으로 변환합니다.
 * @param {string} url - 변환할 URL
 * @returns {string} CSS background-image에 사용할 수 있는 형식의 URL
 */
export const getBackgroundImageUrl = (url) => {
  if (!url) return 'none'
  return `url('${encodeImageUrl(url)}')`
}

/**
 * URL을 안전하게 인코딩합니다.
 * @param {string} url - 인코딩할 URL
 * @returns {string} 인코딩된 URL
 */
export const getSafeUrl = (url) => {
  if (!url) return ''
  return encodeImageUrl(url)
}
